<div class="logo-container">
	@let companyName = authStore.companyName();
	@if (companyLogo$(); as companyLogo) {
		@let resizedLogo$ = companyLogo.webEncode | resizeBase64: 48 : 48;
		<img
			[src]="resizedLogo$()"
			class="company-logo"
			[class.collapsed]="isCollapsed$()"
			[title]="companyName"
			[alt]="companyName"
			loading="lazy"
			fetchpriority="low"
			decoding="async"
		/>
	} @else {
		<div
			class="logo logo-text"
			[class.collapsed]="isCollapsed$()"
		>
			@if (companyName) {
				{{ companyName.charAt(0).toUpperCase() + companyName.slice(1) }}
			}
		</div>
	}
</div>
<button
	class="toggle-btn"
	(click)="toggleSidenav()"
	[class.collapsed]="isCollapsed$()"
>
	<icon [icon]="isCollapsed$() ? 'fa-solid fa-chevron-left' : 'fa-solid fa-chevron-right'" />
</button>
